import { useEffect } from 'react'
import {
  getCurrentSalesforceMessagingLocale,
  loadSalesforceMessaging,
  unloadSalesforceMessaging
} from '../utils/salesforce-web-messaging'
import { Locale } from '../locales'

export function useChat ({
  enabled,
  locale

}: {
  enabled: boolean
  locale: Locale
}): void {
  useEffect(() => {
    void (async function () {
      if (enabled) {
        const currentLocale = getCurrentSalesforceMessagingLocale()
        if (currentLocale != null && currentLocale !== locale) {
          await unloadSalesforceMessaging()
        }
        await loadSalesforceMessaging(locale)
      } else {
        await unloadSalesforceMessaging()
      }
    })()
  }, [enabled, locale])
}
